import { render, staticRenderFns } from "./Form4CaseInformation.vue?vue&type=template&id=3fe34bda&scoped=true"
import script from "./Form4CaseInformation.vue?vue&type=script&lang=ts"
export * from "./Form4CaseInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe34bda",
  null
  
)

export default component.exports